export const scrollToCheckout = () => {
  const checkoutSection = document.getElementById('checkout')
  if (checkoutSection) {
    checkoutSection.scrollIntoView({ behavior: 'smooth' })
  }
}
